import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, FormControl, InputLabel, Select, Input, MenuItem, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core'
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en';
import Calendar from 'react-calendar';
import PropTypes from 'prop-types';



export default class BalanteRows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    fullScreen={true}
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>{this.props.strNume}</h2>

                    <Grid style={{width:'95%', margin:'10px auto'}} container className="pm-dialog-textfield-container" >

                    <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Cont'
                                value={this.props.objRows.simbol || ''}
                                onChange={this.props.changeObj('simbol')}
                                margin="normal"
                                type='text'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Denumire'
                                value={this.props.objRows.denumire || ''}
                                onChange={this.props.changeObj('denumire')}
                                margin="normal"
                                type='text'
                            />

                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Si Debit'
                                value={this.props.objRows.sidebit || ''}
                                onChange={this.props.changeObj('sidebit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Si Credit'
                                value={this.props.objRows.sicredit || ''}
                                onChange={this.props.changeObj('sicredit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='R Debit'
                                value={this.props.objRows.rdebit || ''}
                                onChange={this.props.changeObj('rdebit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='R Credit'
                                value={this.props.objRows.rcredit || ''}
                                onChange={this.props.changeObj('rcredit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Ts Debit'
                                value={this.props.objRows.tsdebit || ''}
                                onChange={this.props.changeObj('tsdebit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Ts Credit'
                                value={this.props.objRows.tscredit || ''}
                                onChange={this.props.changeObj('tscredit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Sf Debit'
                                value={this.props.objRows.sfdebit || ''}
                                onChange={this.props.changeObj('sfdebit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <TextField
                                className="inputFocus loginTextField"
                                style={{ width: '90%' }}
                                label='Sf Credit'
                                value={this.props.objRows.sfcredit || ''}
                                onChange={this.props.changeObj('sfcredit')}
                                margin="normal"
                                type='number'
                            />
                        </Grid>

                        
                        <Grid style={{ textAlign: 'center' }} item xs={12} sm={12} md={12} lg={12} xl={12} >
                             <Button variant="outlined" onClick={this.props.addRow} className='pm-save-button'>
                            {this.props.limba.comune.add}
                        </Button>
                        </Grid>

                        <Grid style={{ textAlign: 'center', height:'90%', overflow:'auto' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.props.listRows.length > 0 &&

                                <Table style={{ width: '90%', margin: 'auto' }}>
                                    <TableHead>
                                        <TableRow >

                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Cont
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Denumire
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Si Debit
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                                Si Credit
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                               R Debit
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                               R Credit
                                            </TableCell>
                               
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                              Ts Debit
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                               Ts Credit
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                              Sf Debit
                                            </TableCell>
                                            <TableCell style={{ fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                                               Sf Credit
                                            </TableCell>


                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.props.listRows.map((l, idx) => {
                                            return (
                                                <TableRow style={{ cursor: 'pointer' }} key={idx}>
                                                    <TableCell style={{ textAlign: 'center' }}>
                                                        {l.simbol}
                                                    </TableCell>

                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.denumire}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.sidebit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.sicredit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.rdebit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.rcredit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.tsdebit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.tscredit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.sfdebit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        {l.sfcredit}
                                                    </TableCell>
                                                    <TableCell style={{ textAlign: 'center' }} >
                                                        <i onClick={()=>{this.props.deleteRow(l)}} style={{color:'#dc2b2b'}} className='material-icons'>delete</i>
                                                    </TableCell>

                                                </TableRow>
                                            )
                                        })}
                                    </TableBody>
                                </Table>
                            }
                        </Grid>

                    </Grid>

                


                </Dialog>
            </div>
        );
    }
}
//end class

BalanteRows.propTypes={
    open:PropTypes.bool,
    dialogClose:PropTypes.func,
    strNume:PropTypes.string,
    objRows:PropTypes.object,
    changeObj:PropTypes.func,
    addRow:PropTypes.func,
    limba:PropTypes.object,
    listRows:PropTypes.array

}